<template>          
      <img :title="db.provider" :src="db.providerIcon">  
</template>
<!-- 
  <ProviderIcon/>
-->

<script>
/* eslint-disable */
import { defineComponent } from 'vue';
export default defineComponent({  
  data() {return {}},  
});
</script>